// extracted by mini-css-extract-plugin
export default {"form":"DiagnosesForm_form__rroVx","toast":"DiagnosesForm_toast__X6LsH"};